export const LEGAL_DOCUMENT_KEYS = [
    "offer",
    "privacy",
    "pdConsent",
];
export const LEGAL_DOCUMENT_URLS = {
    offer: "/docs/public-offer.pdf",
    privacy: "/docs/privacy-policy.pdf",
    pdConsent: "/docs/agreement.pdf",
};
export const LEGAL_DOCUMENT_TITLES = {
    offer: "Публичная оферта",
    privacy: "Политика конфиденциальности",
    pdConsent: "Согласие на обработку персональных данных",
};
const CONSENT_LABELS = {
    offer: "Публичную оферту",
    privacy: "Политикой конфиденциальности",
    pdConsent: "Согласие на обработку персональных данных",
};
export function buildLegalDocuments(urls = {}) {
    return LEGAL_DOCUMENT_KEYS.map((key) => ({
        key,
        title: LEGAL_DOCUMENT_TITLES[key],
        consentLabel: CONSENT_LABELS[key],
        url: urls[key]?.trim() || LEGAL_DOCUMENT_URLS[key],
    }));
}
/** API origin задаёт приложение; shared не читает env. */
export function buildLegalDocumentCurrentUrl(apiOrigin, key) {
    if (!/^https?:\/\/[^/@?#\\\s]+\/?$/.test(apiOrigin)) {
        throw new TypeError("Legal documents API must be an HTTP(S) origin");
    }
    const origin = new URL(apiOrigin);
    if (!/^https?:$/.test(origin.protocol) || origin.username || origin.password || origin.search || origin.hash || origin.pathname !== "/") {
        throw new TypeError("Legal documents API must be an HTTP(S) origin");
    }
    if ((origin.port && (Number(origin.port) < 1 || Number(origin.port) > 65535)) ||
        (!origin.hostname.startsWith("[") && origin.hostname.split(".").some((label) => label.length > 63 || !/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(label)))) {
        throw new TypeError("Legal documents API must be an HTTP(S) origin");
    }
    return new URL(`/public/legal-documents/${key}/current.pdf`, origin).toString();
}
export function buildCurrentLegalDocuments(apiOrigin) {
    return buildLegalDocuments(Object.fromEntries(LEGAL_DOCUMENT_KEYS.map((key) => [key, buildLegalDocumentCurrentUrl(apiOrigin, key)])));
}
//# sourceMappingURL=legal.js.map